import { render, staticRenderFns } from "./oomseries.vue?vue&type=template&id=15457e9a&scoped=true"
import script from "./oomseries.vue?vue&type=script&lang=js"
export * from "./oomseries.vue?vue&type=script&lang=js"
import style0 from "./oomseries.vue?vue&type=style&index=0&id=15457e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15457e9a",
  null
  
)

export default component.exports